module.exports = __webpack_public_path__ + "static/img/company33.dcffb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/company33.png
// module id = o3ML
// module chunks = 0